import React from "react";
import PropTypes from "prop-types";
import SectionItem from "./SectionItem.jsx";

export const ServerDelivery = (props) =>
  (props.server && (
    <span>
      <SectionItem itemKey="Server Delivery">Yes</SectionItem>
      <SectionItem itemKey="FTP/SFTP">
        {props.server.remoteServerType}
      </SectionItem>
      <SectionItem itemKey="Server">{props.server.host}</SectionItem>
      <SectionItem itemKey="Directory">{props.server.directory}</SectionItem>
      <SectionItem itemKey="Username">{props.server.user}</SectionItem>
      <SectionItem itemKey="Passive">
        {props.server.usePassiveMode ? "Yes" : "No"}
      </SectionItem>
    </span>
  )) ||
  null;

export default ServerDelivery;

ServerDelivery.propTypes = {
  server: PropTypes.object,
};
